'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StudioListItem = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _multitrack = require('helpers/multitrack');

var _StarRating = require('../StarRating/StarRating');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StudioListItem = exports.StudioListItem = function StudioListItem(_ref) {
  var type = _ref.type,
      activities = _ref.activities,
      imageUrl = _ref.imageUrl,
      name = _ref.name,
      subtitle = _ref.subtitle,
      hood = _ref.hood,
      alias = _ref.alias,
      rating = _ref.rating,
      venueId = _ref.venueId,
      _onClick = _ref.onClick,
      nolink = _ref.nolink,
      _ref$showRatingNumber = _ref.showRatingNumber,
      showRatingNumber = _ref$showRatingNumber === undefined ? true : _ref$showRatingNumber,
      count = _ref.count;

  var className = 'studio-list-item' + (type === 'no-image' ? ' studio-list-item--no-image' : '');
  var venueContent = _react2.default.createElement(
    'div',
    null,
    type !== 'no-image' && _react2.default.createElement(
      'div',
      { className: 'studio-list-item__image' },
      imageUrl && _react2.default.createElement('div', { style: { backgroundImage: 'url(' + imageUrl + ')' } })
    ),
    _react2.default.createElement(
      'h5',
      { className: 'mb--' },
      name,
      subtitle && ' \u2013 ' + subtitle
    ),
    _react2.default.createElement(
      'div',
      { className: 'mb-' },
      rating >= 0 && _react2.default.createElement(_StarRating.StarRating, {
        showRatingNumber: showRatingNumber,
        rating: rating,
        count: count
      })
    ),
    hood && _react2.default.createElement(
      'p',
      { className: 'studio-list-item__location mb-' },
      hood
    ),
    activities && _react2.default.createElement(
      'p',
      { className: 'text--light' },
      activities.split(',')[0].trim()
    )
  );

  if (nolink) {
    return _react2.default.cloneElement(venueContent, {
      className: className
    });
  }

  return _onClick ? _react2.default.cloneElement(venueContent, {
    onClick: function onClick() {
      return _onClick(venueId);
    },
    className: className
  }) : _react2.default.createElement(
    _reactRouter.Link,
    {
      className: className,
      onClick: function onClick() {
        return (0, _multitrack.ga)('Venue Details', type + ' Click', name);
      },
      to: '/studios/' + alias
    },
    venueContent
  );
};

StudioListItem.propTypes = {
  type: _propTypes2.default.string,
  venueId: _propTypes2.default.number.isRequired,
  activities: _propTypes2.default.string,
  imageUrl: _propTypes2.default.string,
  name: _propTypes2.default.string.isRequired,
  subtitle: _propTypes2.default.string,
  hood: _propTypes2.default.string,
  alias: _propTypes2.default.string.isRequired,
  rating: _propTypes2.default.number,
  onClick: _propTypes2.default.func,
  nolink: _propTypes2.default.bool,
  showRatingNumber: _propTypes2.default.bool,
  count: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
};